module.exports = __webpack_public_path__ + "static/media/search-widger-screenshot.5ca84d06.jpg";